import React, { Component } from 'react';

import { Form, Select } from 'antd';

const FormItem = Form.Item;

class Type extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.value || 1,
            maps: {
                1: {
                    statType: 1,
                    statName: "按学期"
                },
                2: {
                    statType: 2,
                    statName: "按学年"
                }
            }
        };
    }

    componentDidMount() {

    }

    handleChange(data) {
        this.setState({
            value: data.statType
        });

        if(this.props.handleChange) {
            this.props.handleChange(data);
        }
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.hasOwnProperty('value')) {
            this.setState({
                value: nextProps.value
            });
        }
    }

    render() {
        const { width, style, label } = this.props;
        const { value } = this.state;
        const session = JSON.parse(sessionStorage.session);
        return (
            <FormItem label="时间维度">
                <Select
                    placeholder='请选择...'
                    value={value}
                    style={style || {width: width}}
                    onChange={(statType) => {
                        this.handleChange({statType,
                            bgTermId: statType==1?session.account.termId:session.account.yearId,
                            bgTermName: statType==1?session.account.termName:session.account.yearName,
                            endTermId: statType==1?session.account.termId:session.account.yearId,
                            endTermName: statType==1?session.account.termName:session.account.yearName, v: Date.now()});
                    }}
                >
                    {
                        [1, 2].map(value => (
                            <Option value={value}>{this.state.maps[value].statName}</Option>
                        ))
                    }
                </Select>
            </FormItem>
        );
    }
}

export default Type;